import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";
const CustomerPostingGroupAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, load = true, disabled = false, infoText, error, helperText}) => {

    const { t } = useTranslation();

    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.customerPostingGroup")}
            url="/autocompleteApi/CustomerPostingGroup"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={ disabled}
        />
    );
};

export default CustomerPostingGroupAutoComplete;
